var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7092 1.04578C30.0952 0.659837 29.8213 0 29.2776 0H25.6713C24.5135 0 23.4014 0.460641 22.5797 1.27817L15.9979 7.85994L19.4465 11.3085L29.7092 1.04578Z",
    fill: "#624BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.541 11.321L14.6741 13.4416C15.4086 14.1678 16.5872 14.1678 17.3217 13.4416L19.0771 11.6986L19.4465 11.3085L15.9979 7.85996L13.8234 5.6854C13.0224 4.88447 11.9351 4.43213 10.7981 4.43213H5.67706L12.5493 11.3044L12.541 11.321Z",
    fill: "#A79AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29071 30.9584C1.90477 31.3444 2.17867 32.0001 2.7223 32.0001H6.36593C7.50301 32.0001 8.59029 31.5477 9.39122 30.7468L15.9979 24.1401L12.5493 20.6915L2.29071 30.9584Z",
    fill: "#624BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3259 18.5626C16.5914 17.8322 15.4086 17.8322 14.6741 18.5626L12.9228 20.3014L12.5535 20.6915L16.0021 24.14L18.1476 26.2856C18.9693 27.1072 20.0814 27.5679 21.2434 27.5679H26.3229L19.4507 20.6956L19.4631 20.6832L17.3259 18.5626Z",
    fill: "#A79AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85994 16.002L5.70198 18.16L11.3168 12.5451L1.03748 2.2824C0.655687 1.90061 0 2.17035 0 2.71399V6.34102C0 7.50299 0.452344 8.59857 1.27403 9.42025L7.85994 16.002Z",
    fill: "#624BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43207 21.2226V26.3229L11.3043 19.4506L11.3168 19.4631L13.4457 17.3176C14.1761 16.583 14.1719 15.3962 13.4415 14.6658L11.3168 12.5452L5.70194 18.16C4.88856 18.9692 4.43207 20.0731 4.43207 21.2226Z",
    fill: "#A79AFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7413 19.4258L30.9833 29.7383C31.3568 30.1159 32 29.8503 32 29.3192V25.6465C32 24.497 31.5518 23.4138 30.7426 22.5963L24.1774 15.9979L20.7413 19.4258Z",
    fill: "#624BFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5886 10.8272V5.67712L20.7454 12.5535L20.733 12.5411L18.6373 14.6575C17.9152 15.3879 17.911 16.5582 18.6248 17.2927L20.7413 19.4216L26.3561 13.8068C27.1446 13.0183 27.5886 11.9435 27.5886 10.8272Z",
    fill: "#A79AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo1);
export default __webpack_public_path__ + "static/media/brand-logo-1.60494f3c21cb98293bca796b9d6749a7.svg";
export { ForwardRef as ReactComponent };